// Copyright 2026, Imprivata, Inc.  All rights reserved.

/**
 * Wraps a raw base64 certificate body in PEM markers, breaking the body
 * into 76-character lines per the PEM convention.
 */
export const formatCertAsPem = (base64: string): string => {
  const body = base64.length === 0 ? '' : (base64.match(/.{1,76}/g)?.join('\n') ?? base64);
  return `-----BEGIN CERTIFICATE-----\n${body}\n-----END CERTIFICATE-----\n`;
};
